import {
  GamesUIComponentFilterType,
  ItemWithTranslation,
  SportsCacheMenuManifestazioniSportDto,
  SportsVoceMenu,
} from 'types/swagger';

export type MenuManifestazioniResponseApi = {
  gruppi: Array<SportsVoceMenu>;
  preferiti: Array<Preferito>;
  idDisciplina: number;
  descrizioneDisciplina: string;
};

export type Preferito = {
  id: number;
  attivo: boolean;
  descrizione: string;
};

export interface ElementWithQuote {
  quotaMax: number;
  quotaMin: number;
}

/* eslint-disable no-unused-vars */
export enum Schedule {
  default = 'default',
  prossime12Ore = 'prossime12Ore',
  prossime24Ore = 'prossime24Ore',
  oggi = 'oggi',
  domani = 'domani',
}
/* eslint-enable no-unused-vars */

export const ScheduleOptions = Object.keys(Schedule);
export type ScheduleType = keyof typeof Schedule;

export type ElementWithTime = Record<Schedule, boolean | undefined>;

export type ElementToFilter = ElementWithQuote & Omit<ElementWithTime, 'default'>;

export interface TimingFilterItem {
  label: string;
  value: ScheduleType;
}

export interface QuoteFilterItem {
  step: number;
  range: Array<number>;
  labelMin: string;
  labelMax: string;
  direction: string;
  defaultValue: Array<number>;
}

export type SportFilterItem<T> = {
  type: GamesUIComponentFilterType | string;
  values: Array<T>;
} & ItemWithTranslation<{
  name: string;
  description: string;
}>;

export type SportFiltersType = Record<string, SportFilterItem<any>>;

export const sequence = ['quote', 'schedule'];

export interface SportsMenuManifestazioni extends SportsCacheMenuManifestazioniSportDto {
  slug: string;
}
